<template>
  <AppFilterToolbar>
    <template v-if="$slots.create" #create><slot name="create" /></template>
    <template #primary>
      <app-input design="new" :value="value.search" type="search" placeholder="Search by name, email, phone or ID" aria-label="Search leads" @input="updateFilter('search', $event || '')" />
    </template>
    <app-select design="new" :value="value.country" :options="countries" :reduce="country => country.code || country.id" placeholder="Country" aria-label="Country" @input="updateFilter('country', $event)">
      <template #custom-option="country"><span class="ui-cell-inline"><span :class="`fflag ff-sm fflag-${country.code || 'empty'}`" aria-hidden="true" /><span>{{ country.name }}</span></span></template>
    </app-select>
    <app-select design="new" :value="value.activity" :options="activityOptions" :reduce="activity => activity.code" multiple placeholder="Activity" aria-label="Activity" @input="updateFilter('activity', $event || [])" />

    <LeadFlowManagerSelect v-if="showManager" :value="value.manager" :options="managers" :loading="managersLoading" :loading-more="managersLoadingMore" :has-more="managerHasMore" :error="managerError" @input="updateFilter('manager', $event)" @open="$emit('manager-open')" @search="$emit('manager-search', $event)" @load-more="$emit('manager-load-more')" @retry="$emit('manager-retry')" />
    <template v-if="showAdvancedFilters">
      <app-date-picker design="new" :value="value.requestDates" range placeholder="Request date" :input-attr="{ 'aria-label': 'Request date' }" @input="updateFilter('requestDates', $event || [])" />
      <app-date-picker design="new" :value="value.confirmationDates" range placeholder="Confirmation date" :input-attr="{ 'aria-label': 'Confirmation date' }" @input="updateFilter('confirmationDates', $event || [])" />
      <app-date-picker design="new" :value="value.travelDates" range placeholder="Travel dates" :input-attr="{ 'aria-label': 'Travel dates' }" @input="updateFilter('travelDates', $event || [])" />
      <app-select design="new" :value="value.advSources" :options="advSources" :reduce="source => source.code" label="name" multiple placeholder="Advertising sources" aria-label="Advertising sources" @input="updateFilter('advSources', $event || [])" />
      <app-select design="new" :value="value.tourOperators" :options="tourOperators" :reduce="operator => operator.id" label="name" multiple placeholder="Tour operators" aria-label="Tour operators" @input="updateFilter('tourOperators', $event || [])" />
      <app-select design="new" :value="value.domains" :options="domains" :reduce="domain => domain.id" label="domain_name" multiple placeholder="Request domains" aria-label="Request domains" @input="updateFilter('domains', $event || [])" />
    </template>
    <template v-if="$slots.actions" #actions><slot name="actions" /></template>
    <template v-if="hasActiveFilters" #clear><AppClearFiltersButton design="new" icon-only @clear="$emit('clear')" /></template>
  </AppFilterToolbar>
</template>

<script>
import LeadFlowManagerSelect from '@/views/crm/task-tracker/LeadFlowManagerSelect.vue'

export default {
  name: 'LeadFlowFilters',
  components: {
    LeadFlowManagerSelect
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    countries: {
      type: Array,
      default: () => []
    },
    advSources: {
      type: Array,
      default: () => []
    },
    tourOperators: {
      type: Array,
      default: () => []
    },
    domains: {
      type: Array,
      default: () => []
    },
    managers: {
      type: Array,
      default: () => []
    },
    managersLoading: {
      type: Boolean,
      default: false
    },
    managersLoadingMore: {
      type: Boolean,
      default: false
    },
    managerHasMore: {
      type: Boolean,
      default: false
    },
    managerError: {
      default: null
    },
    showManager: {
      type: Boolean,
      default: false
    },
    showAdvancedFilters: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activityOptions: [
        { code: 'climbing', name: 'Climbing' },
        { code: 'safari', name: 'Safari' },
        { code: 'day_trip', name: 'Day trips' },
        { code: 'island', name: 'Island vacation' }
      ]
    }
  },
  computed: {
    advancedFilterCount() {
      return [
        this.value.requestDates,
        this.value.confirmationDates,
        this.value.travelDates,
        this.value.advSources,
        this.value.tourOperators,
        this.value.domains
      ].filter(value => Array.isArray(value) ? value.length : value).length
    },
    hasActiveFilters() {
      return Boolean(
        (this.value.search || '').trim()
        || this.value.country
        || (this.value.activity || []).length
        || this.value.manager
        || this.advancedFilterCount
      )
    }
  },
  methods: {
    updateFilter(name, value) {
      this.$emit(
        'change',
        {
          ...this.value,
          [name]: value
        },
        name
      )
    }
  }
}
</script>
